<template>
  <!-- 横屏 -->
  <horizontalScreen class="v-game-course"> 
    <!-- <scaleWrap> -->
      <div class="home">
        <div class="box" id="box">
          <div class="word-container">
            <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index)" :id="`word${index}`" class="word" v-for="(word, index) in showWordList.slice(0, 1)" :key="word.name">
              <img class="flower" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-4/anime/type0/0.png"/>
              <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index)">
                <div class="icon-img" :style="{backgroundImage: 'url(' + word.icon + ')'}"> 
                </div> 
              </div>
            </div>
          </div>
          <div class="word-container">
            <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+1)" :id="`word${index+1}`" class="word" v-for="(word, index) in showWordList.slice(1, 3)" :key="word.name">
              <img class="flower" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-4/anime/type0/0.png"/>
              <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+1)">
                <div class="icon-img" :style="{backgroundImage: 'url(' + word.icon + ')'}"> 
                </div> 
              </div>
            </div>
          </div>
          <div class="word-container">
            <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+3)" :id="`word${index+3}`" class="word" v-for="(word, index) in showWordList.slice(3, 6)" :key="word.name">
              <img class="flower" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-4/anime/type0/0.png"/>
              <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+3)">
                <div class="icon-img" :style="{backgroundImage: 'url(' + word.icon + ')'}"> 
                </div> 
              </div>
            </div>
          </div>
        </div>   
        
        <!-- <div class="word-container">
          <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+6)" :id="`word${index+6}`" class="word" v-for="(word, index) in showWordList.slice(6, 9)" :key="word.name">
            <img src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-4/anime/type0/0.png"/>
            <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+6)" :style="{backgroundImage: 'url(' + word.icon + ')'}"></div>
          </div>
        </div> -->
        <img id="person" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-4/walk/0.png">
        <!-- <img id="partner" src="@/assets/game3-4/clap/0.png"> -->
        <img class="logo" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/logo.png"/>
        <div class="sound-box-top" :style="{right: height < 700 ? '10px' : null}">
           <img @click="backHandler" class="back" src="@/assets/back.png"/>
           <img @click.stop.prevent="reverseHandler" class="reverse" src="@/assets/reverse.png"/>
           <img @click="startHandler" class="voice" src="@/assets/voice.png"/>
        </div>
        <!-- <div class="sound-box-bottom"> -->
           <!-- <img @click="backHandler" class="back" src="@/assets/back.png"/> -->
           <!-- <img @click="reverseHandler" class="reverse" src="@/assets/reverse.png"/> -->
           <!-- <img @click.stop.prevent="startHandler" class="voice" src="@/assets/voice.png"/> -->
        <!-- </div> -->
        <audio id="myAudio" preload="auto"></audio>
        <audio id="failAudio" preload="auto">
          <source :src="this.failAudio">
        </audio>
        <audio id="downAudio" preload="auto">
          <source :src="this.downAudio">
        </audio>
        <audio id="walkAudio" preload="auto">
          <source :src="this.walkAudio">
        </audio>
        <audio id="upAudio" preload="auto">
          <source :src="this.upAudio">
        </audio>
        <Overlay class="mask-dialog" :show="showStartGameIcon">
          <img class="overlay-bg" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-4/bg.png"/>
          <div class="sound-box-top" :style="{right: height < 700 ? '10px' : null}">
            <img @click="backHandler" class="back" src="@/assets/back.png"/>
            <!-- <img @click.stop.prevent="reverseHandler" class="reverse" src="@/assets/reverse.png"/>
            <img @click="startHandler" class="voice" src="@/assets/voice.png"/> -->
          </div>
          <div class="mask-title">{{index}} {{gameName}}</div>
          <img @click="startGameHandler(true)" class="start" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/btn-start.png"/>
        </Overlay>
      </div>
    <!-- </scaleWrap> -->
  </horizontalScreen>
</template>
<script>
import anime from 'animejs/lib/anime.es.js'
import horizontalScreen from '@/components/horizontal-screen'
// import scaleWrap from '@/components/scale-wrap'
import {shuffle, isEmpty, cloneDeep} from 'lodash'
import { Overlay } from 'vant'
import mixin from '../mixin'
import {Howl} from 'howler'
import {isIOS} from '@/utils/env'

export default {
  name: 'GameCourse',
  mixins: [mixin],
  components: {
    // , scaleWrap
    horizontalScreen, Overlay
  },
  created () {
    this.walkAudioVoice = new Howl({
      src: [this.walkAudio],
      html5: isIOS
    });
    this.upAudioVoice = new Howl({
      src: [this.upAudio],
      html5: isIOS
    });
    this.downAudioVoice = new Howl({
      src: [this.downAudio],
      html5: isIOS
    });
  },
  beforeDestroy () {
    this.walkAudioVoice.pause()
    this.upAudioVoice.pause()
    this.downAudioVoice.pause()
  },
  data() {
    return {
      walkAudioVoice: null,
      upAudioVoice: null,
      downAudioVoice: null,
      personTarget: {
        right: null,
        bottom: null
      },
      index: this.$route.query.index,
      id: this.$route.query.id,
      gameName: null,
      walkAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-4/sounds/ready.mp3`,
      upAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-4/sounds/up.mp3`,
      downAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-4/sounds/down.mp3`,
      clickAudio: require(`@/assets/sounds/click.mp3`),
      failAudio: require(`@/assets/sounds/fail.mp3`),
      boardImgLength: 0, // 花苞
      workImgLength: 60, // 小人走路动画
      digImgLength: 100
    }
  },
  watch: {
    isWalk(val) {
      this.$nextTick(() => {
        const person = document.getElementById('person')
        if (val) {
          person.style.zIndex = 60
        } else {
          console.log('person.style.right', person.style.right, this.personTarget.right)
          if (!person.style.right || person.style.right.slice(0,-2) == this.personTarget.right) {
            person.style.zIndex = 40
          }
        }
      })
    }
  },
  mounted() {
    this.initPersonLocation()
  },
  methods: {
    isEmpty,
    initPersonLocation(){
      const personTarget = document.getElementById('person')
      if (this.isVertical) {
        this.personTarget.bottom = document.body.clientWidth - personTarget.offsetTop - personTarget.offsetHeight
        this.personTarget.right = document.body.clientHeight - personTarget.offsetLeft - personTarget.offsetWidth
      } else {
        this.personTarget.bottom = document.body.clientHeight - personTarget.offsetTop - personTarget.offsetHeight
        this.personTarget.right = document.body.clientWidth - personTarget.offsetLeft - personTarget.offsetWidth
      }
     
    },
    // 走路动画
    personWalkGifHandler () {
      clearInterval(this.timerWalk)
      this.timerWalk = null
      let i = 0
      const person = document.getElementById('person')
      this.timerWalk = setInterval(() => {
        this.isWalk = true
        // 前面17张走路
        if (i>=this.workImgLength) {
          clearInterval(this.timerWalk)
          this.timerWalk = null
          // this.isWalk = false
        } else {
          i=i+1
          person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-4/walk/${i}.png`
        }
      }, 60)
    },
    // 挖宝动画
    personDigGifHandler () {
      clearInterval(this.timerDig)
      this.timerDig = null
      let i = this.workImgLength
      const person = document.getElementById('person')
      this.timerDig = setInterval(() => {
        this.isWalk = true
        if (i >= this.digImgLength -1) {
          clearInterval(this.timerDig)
          this.timerDig = null
          // this.isWalk = false
          person.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-4/walk/${0}.png`
        } else {
          i=i+1
          person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-4/walk/${i}.png`
        }
      }, 100)
    },
    // 打乱文字排序
    async reverseHandler() {
      if (!this.isWalk){
        clearInterval(this.timerWalk)
        this.timerWalk = null
        clearInterval(this.timerSigh)
        this.timerSigh = null
        clearInterval(this.timerClap)
        this.timerClap = null
        clearInterval(this.timerDig)
        this.timerDig = null
        clearInterval(this.timerBoard)
        this.timerBoard = null

        const person = document.getElementById('person')
        person.style.left = null
        person.style.top = null
        person.style.bottom = `${this.personTarget.bottom}px`
        person.style.right = `${this.personTarget.right}px`
        
        

        this.audioList = []
        await this.initData()
        
        this.showWordList = shuffle(this.InitWordList)
        this.wordList = cloneDeep(this.showWordList)
        this.$set(this, 'showWordList', shuffle(this.InitWordList)) 
        this.$set(this, 'wordList', cloneDeep(this.showWordList)) 
        for(let i =0;i<this.InitWordList.length;i++) {
          const word = document.getElementById(`word${i}`)
          const flowerTarget = document.querySelector(`#word${i} .flower`)
          const wordTarget = document.querySelector(`#word${i} div`)
          word.style.visibility = 'visible'
          wordTarget.style.display = 'block'
          flowerTarget.style.display = 'block'
          flowerTarget.style.left = '0px'
          flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-4/anime/type0/${0}.png`
        }
         for(let i =0;i<this.showWordList.length;i++) {
          this.showWordList[i].clicked = false
          const word = document.getElementById(`word${i}`)
          const flowerTarget = document.querySelector(`#word${i} .flower`)
          const wordTarget = document.querySelector(`#word${i} div`)
          word.style.visibility = 'visible'
          wordTarget.style.display = 'block'
          flowerTarget.style.display = 'block'
          flowerTarget.style.left = '0px'
          flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-4/anime/type0/${0}.png`
        }
        // 一切重新开始
        this.getData()
        this.startGameHandler()
      }
    },
    // 字点击
    wordClickHandler(event, word, index) {
      console.log('word', word, event.target.className)
      console.log('isWalk', this.isWalk)

      if (this.isWalk) return

      let parentNode = event.target.parentElement
      if (event.target.className == 'icon-img') {
        parentNode = event.target.parentElement.parentElement
      } else {
        parentNode = event.target.parentElement
      }
      anime({
        targets: parentNode,
        scale: [
          { value: 1, duration: 100 },
          { value: 1.1, duration: 100 },
          { value: 1, duration: 100 }
        ],
        complete: () => {
          parentNode.style.transform = 'none'
        }
      });
      
      if (this.currentWord.name !== word.name) {
        this.playClickAudio()
        this.playFailAudio()
        return false
      }

      this.showWordList[index].clicked = true
      this.playClickAudio()
      // document.getElementById(`walkAudio`).play()
      this.walkAudioVoice.play()
      setTimeout(() => {
        // document.getElementById(`upAudio`).play()
        this.upAudioVoice.play()
        const target = document.getElementById(`word${index}`)
        const person = document.getElementById('person')
        console.log('ggg', target)
        this.personWalkGifHandler()
        // 变换成第一个花苞
        const iconTarget = document.querySelector(`#word${index} .icon`)
        const flowerTarget = document.querySelector(`#word${index} .flower`)
        // const boxTarget = document.querySelector(`#box`)
        // 隐藏花
        flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-4/anime/type0/${0}.png`
        iconTarget.style.display = 'none'
        // const word1 = document.getElementById(`word${1}`)

        console.log('isVertical', this.isVertical)
        // lightTarget.style.display = 'block'
        this.animation = anime({
          targets: person,
          rotate: 30,
          // bottom: `${boxTarget.offsetTop + person.offsetHeight*0.4}px`,
          bottom: !this.isVertical ? `${document.body.clientHeight * 0.55}px` : `${document.body.clientWidth* 0.55}px`,
          right: !this.isVertical ? `${document.body.clientHeight*0.36 + person.offsetWidth*0.8}px` : `${document.body.clientWidth*0.36+ person.offsetWidth*0.8}px`,
          // bottom: this.isVertical ? `${target.getBoundingClientRect().x+80}px` : null,
          // left: this.isVertical ? `${target.getBoundingClientRect().y-10}px` : `${target.getBoundingClientRect().x-15}px`,
          // // left:  !this.isVertical ? `${target.getBoundingClientRect().x-15}px` : null,
          // top: !this.isVertical ? `${target.getBoundingClientRect().y+30}px` : null,
          easing: 'easeInOutQuad',
          duration: this.workImgLength*60, // 走路多久到达的时间 走路的动作乘以时间
          complete: () => {
            person.style.transform = 'rotate(0deg)'
          
            clearInterval(this.timerWalk)

            this.personDigGifHandler(`word${index}`)
            this.animation2 = anime({
              targets: person,
              rotate: 0,
              right: !this.isVertical ? `${document.body.clientHeight*0.36 + person.offsetWidth*1.8}px` : `${document.body.clientWidth*0.36+ person.offsetWidth*1.8}px`,
              // bottom: `${this.personTarget.bottom}px`,
              // right: this.isVertical ? `${(document.body.clientHeight-person.offsetWidth*0.2)}px` : `${(document.body.clientWidth-person.offsetWidth*0.2)}px`,
              // right: this.isVertical ? `${(document.body.clientHeight + person.offsetWidth)}px` : `${(document.body.clientWidth + person.offsetWidth)}px`,
              easing: 'easeInOutQuad',
              duration: (5)*300, // 走路多久到达的时间 走路的动作乘以时间
              complete: () => {
                // document.getElementById('downAudio').play()
                this.downAudioVoice.play()
                this.animation3 = anime({
                targets: person,
                rotate: -34,
                // keyframes: [
                //   {rotate: -20},
                //   {rotate: -34},
                //   {rotate: -34},
                //   {rotate: -34},
                //   {rotate: -38},
                //   {rotate: -39},
                //   {rotate: -40}
                // ],
                bottom: `${this.personTarget.bottom}px`,
                right: this.isVertical ? `${(document.body.clientHeight-person.offsetWidth*0.2)}px` : `${(document.body.clientWidth-person.offsetWidth*0.2)}px`,
                // right: this.isVertical ? `${(document.body.clientHeight + person.offsetWidth)}px` : `${(document.body.clientWidth + person.offsetWidth)}px`,
                easing: 'easeInOutQuad',
                duration: (this.digImgLength-this.workImgLength-15)*100, // 走路多久到达的时间 走路的动作乘以时间
                complete: () => {
                  person.style.transform = 'rotate(-25deg)'
                  this.animation4 = anime({
                    targets: person,
                    rotate: -15,
                    bottom: `${this.personTarget.bottom + person.offsetHeight*0.2}px`,
                    right: this.isVertical ? `${(document.body.clientHeight + person.offsetWidth)}px` : `${(document.body.clientWidth + person.offsetWidth)}px`,
                    easing: 'easeInOutQuad',
                    duration: 10*100, // 走路多久到达的时间 走路的动作乘以时间
                    complete: () => {
                      person.style.transform = 'rotate(0deg)'
                      flowerTarget.style.display = 'none'
                      person.style.left = null
                      person.style.top = null
                      person.style.bottom = `${this.personTarget.bottom}px`
                      person.style.right = `${this.personTarget.right}px`
                      this.getData(true)
                      
                    }
                  });
                  
                }
              });
                
              }
            });
            // this.boardGifHandler(`word${index}`, index)
          }
        });
      }, 2000)

      
    }
  }
}
</script>

<style lang="scss" scoped>
.v-game-course{
  // font-family: 'Alibaba-PuHuiTi-Bold';
  // font-family: 'FZHuPo-M04S';
audio {
  position: absolute;
  top: -1000px;
  left: -1000px;
  z-index: -1;
}
.mask-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  // background: url(~https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-4/bg.png) center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  .overlay-bg {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: -1;
  }
   .mask-title {
    border: solid 3px #5f0001;
    color: #5f0001;
    font-size: 50px;
    padding: 20px 0;
    text-align: center;
    background: #fff;
    border-radius: 60px;
    width: 76%;
    margin: 5% auto;
  }
  .start {
    display: block;
    width: 124px;
  }
  .btn-restart {
    width: 223.33px;
  }
}

.home {
  height: 100%;
  width: 100%;
  background: url(https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game3-4/bg.png) center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
}
// .logo {
//   width: 12px;
//   left: 5px;
//   top: 10PX;
//   position: fixed;
// }
.sound-box-top {
  width: 46px;
  right: 20px;
  top: 10PX;
  z-index: 990;
  position: fixed;
  > img {
    display: block;
    width: 46px;
    & + img {
      margin-top: 10px;
    }
  }
}
.sound-box-bottom {
  z-index: 990;
  width: 46px;
  right: 5px;
  bottom: 5px;
  position: fixed;
  > img {
    display: block;
    width: 46px;
    & + img {
      margin-top: 10px;
    }
  }
}
.box {
  position: absolute;
  left: 18%;
  height: 60%;
  bottom: 0;
  right: 33%;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
}
.word-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  height: 75px;
  &:nth-of-type(1) {
  }
  &:nth-of-type(2) {
    margin-top: -10px;
  }
  &:nth-of-type(3) {
    margin-top: -10px;
  }
  .word {
    transform-origin: center;
    width: 25%;
    height: 25%;
    font-size: 30px;
    // font-weight: bolder;
    position: relative;
    .flower {
      position: absolute; 
      width: 100%;
    }
    & + .word {
      margin-left: 30px;
    }
    .icon {
      z-index: 60;
      display: block;
      width: 100%;
      height: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0%;
    }
    .icon-img {
      z-index: 60;
      display: block;
      width: 74px;
      height: 74px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 53%;
      transform: translateX(-50%);
      top: 12%;
    }
  }
}
#person {
  width: 178.16px;
  height: 178.66px;
  position: fixed;
  right: 40px;
  bottom: 40px;
  z-index: 40;
}
#partner {
  width: 159.75px;
  height: 68.75px;
  position: fixed;
  right: 10px;
  bottom: 0px;
}
}
</style>